import { orderBy } from 'lodash';
import { ItemTypeSong } from '~/features/dashboard/components/song-details/coponents/EditSynchTab';

export type ItemType = {
    id: number;
    title: string;
};

export const getAddressString = (addressLines: string[]) => {
    const addresses = [];
    for (const addressLine of addressLines) {
        if (addressLine) {
            addresses.push(addressLine);
        }
    }
    return addresses.join(', ');
};

export function deepEqual(object1: any, object2: any) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
            return false;
        }
    }

    return true;
}

function isObject(object: any) {
    return object != null && typeof object === 'object';
}

export function sortItems(itemsToSort: ItemType[]) {
    return orderBy(itemsToSort, [({ title }) => (title.toLowerCase() === 'other' ? 1 : 0), 'title'], ['asc']);
}

export function sortSongItems(itemsToSort: ItemTypeSong[]) {
    return orderBy(itemsToSort, [({ listingText }) => (listingText.toLowerCase() === 'other' ? 1 : 0), 'listingText'], ['asc']);
}
